import { render } from "./ConsiderationFormControl.vue?vue&type=template&id=04a96e6e&scoped=true"
import script from "./ConsiderationFormControl.vue?vue&type=script&lang=js"
export * from "./ConsiderationFormControl.vue?vue&type=script&lang=js"

import "./ConsiderationFormControl.vue?vue&type=style&index=0&id=04a96e6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a96e6e"]])

export default __exports__